import type { StatItem } from '../../types';

interface HeroProps {
  stats: StatItem[];
}

const Hero = ({ stats }: HeroProps) => {
  return (
    <section className="hero-section container" id="inicio">
      <div className="hero-main-card">
        <span className="eyebrow-chip">Nueva colección</span>
        <h1>Una vitrina moderna inspirada en una tienda real de moda.</h1>
        <p>
          Esta demo en React + TypeScript replica una estructura tipo e-commerce con categorías,
          productos destacados, llamadas a la acción y secciones listas para conectar al backend.
        </p>

        <div className="hero-buttons">
          <a href="#destacados" className="primary-button">
            Ver destacados
          </a>
          <a href="#categorias" className="secondary-button">
            Explorar categorías
          </a>
        </div>

        <div className="hero-stats-grid">
          {stats.map((stat) => (
            <article key={stat.id} className="stat-card">
              <strong>{stat.value}</strong>
              <span>{stat.label}</span>
            </article>
          ))}
        </div>
      </div>

      <div className="hero-side-column">
        <article className="hero-aside-card hero-aside-blue">
          <span className="card-overline">Tienda</span>
          <h3>Diseño limpio para destacar producto y promociones.</h3>
          <p>Ideal para una home enfocada en conversión y branding.</p>
        </article>

        <article className="hero-aside-card hero-aside-cream">
          <span className="card-overline">Implementación</span>
          <h3>Componentes separados para que cada módulo crezca por aparte.</h3>
          <p>Perfecto para integrar catálogo, carrito, login y filtros más adelante.</p>
        </article>
      </div>
    </section>
  );
};

export default Hero;
